<template>
    <q-card-section class="modal-content">
        <div class="d-flex justify-start modal-title-wrapper">
            <span class="modal-title">Задать вопрос о товаре</span>
        </div>

        <q-input
            outlined
            class="required"
            v-model="form.name"
            @input="form.errors.clear('name')"
            :error-message="form.errors.get('name')"
            :error="form.errors.has('name')"
            label="Ваше имя" />

        <q-input
            outlined
            class="required"
            v-model="form.email"
            @input="form.errors.clear('email')"
            :error-message="form.errors.get('email')"
            :error="form.errors.has('email')"
            label="Email" />

        <q-input
            outlined
            class="required"
            label="Ваш вопрос"
            v-model="form.question"
            type="textarea"
            @input="form.errors.clear('question')"
            :error-message="form.errors.get('question')"
            :error="form.errors.has('question')"
        />

        <q-card-actions class="q-pa-none q-mt-sm">
            <q-btn class="full-width" label="Отправить" @click.prevent="submitQuestion" />
        </q-card-actions>
    </q-card-section>
</template>

<script>
    import { mapMutations } from 'vuex';
    import { Form } from "../../../classes/Form";

    export default {
        name: 'AddProductQuestion',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data () {
            return {
                form: new Form({
                    name: '',
                    email: '',
                    question: '',
                }),
            }
        },
        mounted () {
            if (this.$root.account()) {
                this.form.name = this.$root.account().first_name;
                this.form.email = this.$root.account().email;
            }
        },
        methods: {
            ...mapMutations('product', [
                'hideFeedbackModal',
            ]),

            submit () {
                let _this = this;

                _this.responseMessage = '';

                _this.form.post('/products/' + _this.id + '/questions')
                    .then(response => {
                        _this.hideFeedbackModal();

                        _this.form.reset();

                        _this.$emit('submitted', 'Мы ответим на него в ближайшее время', 'Спасибо за Ваш вопрос.');
                    });
            },

            submitQuestion () {
                let _this = this;
                _this.submit();
            }
        },
        computed: {
            modal: {
                get () {
                    return this.$store.state.product.modal === 'question';
                },
                set (value) {
                    this.hideFeedbackModal();
                }
            },
        }
    }
</script>
